import { Injectable } from "@angular/core";
import { WawiConnectorExecutable, WawiConnectorNonExecutable, WawiConnectorType } from "./wawi-connector.types";
import { Platform } from "@ionic/angular";
import { AppAvailability } from "@awesome-cordova-plugins/app-availability/ngx";
import { WawitogoAppConnectorService } from "./wawi-connectors/wawitogo-app-connector.service";
import { WebConnectorService } from "./wawi-connectors/web-connector.service";
import { GeneralService } from "../general.service";
import { WawitogoWebConnectorService } from "./wawi-connectors/wawitogo-web-connector.service";
import { HttpClient } from "@angular/common/http";
import { HttpFunctionResult } from "src/app/_interfaces/HttpFunctionResult";

@Injectable({
  providedIn: 'root'
})
export class WawiConnectorService {

    public connector: WawiConnectorExecutable | WawiConnectorNonExecutable  = {
        type: WawiConnectorType.NOTHING,
        executable: false
    }
    
    public get appName(): string{
        switch(this.connector.type){
            case WawiConnectorType.WAWITOGO_APP:
            case WawiConnectorType.WAWITOGO_WEB: return "WaWi-ToGo";
            case WawiConnectorType.WEBCONNECTOR: return "AFS-Manager";
            default: return ""
        }
    }

    constructor(
        private platform: Platform,
        private appAvailability: AppAvailability,
        private generalSrv: GeneralService,
        private http: HttpClient
    ){

    }

    /**
     * Initialisiert den Wawi-Connector basierend auf der Plattform und den verfügbaren Konnektoren.
     */
    public async initConnector(): Promise<void>{
        if(this.platform.is("capacitor") && await WawitogoAppConnectorService.isAvailable(this.platform, this.appAvailability)) 
            this.connector = new WawitogoAppConnectorService()
        else if(await WebConnectorService.isAvailable(this.http)) 
            this.connector = new WebConnectorService(this.http)
        else if(this.generalSrv.webConfig?.wawitogo_url) 
            this.connector = new WawitogoWebConnectorService(this.generalSrv.webConfig.wawitogo_url);
    }

    /**
     * Gibt zurück ob der AFS-Webconnector installiert ist und ob der AFS-Manager geöffnet ist.
     * @returns 
     */
    public async getWebconnectorState(): Promise<[installed: boolean, managerOpen: boolean]>{
        const connector: WebConnectorService = new WebConnectorService(this.http)
        const stateResult: HttpFunctionResult<number> = await connector.executeCommand("api/Manager");
        return [(stateResult.success || stateResult.data == 503), stateResult.success];
    }

    /**
     * downloaded den AFS-Webconnector.
     */
    public async downloadWebconnector(){
        window.open(this.generalSrv.webConfig?.webconnector_download_url, "_blank");
    }

}